// Room lifecycle messages for transition messages

import type { TransitionMessages } from '../../types';

export const ROOM_LIFECYCLE: Record<string, TransitionMessages> = {
  loadingRoom: {
    top: {
      'en-US': 'Loading room...',
      'en-GB': 'Loading the room...',
      'en-AU': 'Loading your room...',
      'en-IN': 'Room is being loaded...',
      'es-ES': 'Cargando sala...',
      'es-US': 'Cargando sala...',
    },
  },
  connectingToRoom: {
    top: {
      'en-US': 'Connecting to room',
      'en-GB': 'Connecting to the room',
      'en-AU': 'Connecting to your room',
      'en-IN': 'Connecting to the room',
      'es-ES': 'Conectando a la sala',
      'es-US': 'Conectando a la sala',
    },
  },
  startingRoom: {
    top: {
      'en-US': 'Starting the room',
      'en-GB': 'Starting the room',
      'en-AU': 'Starting your room',
      'en-IN': 'Starting your room',
      'es-ES': 'Iniciando la sala',
      'es-US': 'Iniciando la sala',
    },
  },
  startingGame: {
    top: {
      'en-US': 'Starting the game...',
      'en-GB': 'Starting the game...',
      'en-AU': 'Starting the game...',
      'en-IN': 'Starting the game...',
      'es-ES': 'Iniciando el juego...',
      'es-US': 'Iniciando el juego...',
    },
  },
  preparingNextRound: {
    top: {
      'en-US': 'Preparing next round',
      'en-GB': 'Preparing next round',
      'en-AU': 'Preparing next round',
      'en-IN': 'Preparing next round',
      'es-ES': 'Preparando la siguiente ronda',
      'es-US': 'Preparando la siguiente ronda',
    },
  },
  waitingForGameStart: {
    top: {
      'en-US': 'Waiting for game to start...',
      'en-GB': 'Waiting for the game to begin...',
      'en-AU': 'Waiting for the game to start...',
      'en-IN': 'Waiting for the game to begin...',
      'es-ES': 'Esperando a que empiece el juego...',
      'es-US': 'Esperando que empiece el juego...',
    },
  },
  roomClosed: {
    top: {
      'en-US': 'Game room has been closed',
      'en-GB': 'The game room has been shut down',
      'en-AU': "Looks like the room's closed",
      'en-IN': 'The game room has been closed',
      'es-ES': 'La sala de juego se ha cerrado',
      'es-US': 'La sala de juego se cerró',
    },
  },
};
